import script from "./FireStations.vue?vue&type=script&setup=true&lang=js"
export * from "./FireStations.vue?vue&type=script&setup=true&lang=js"

import "./FireStations.vue?vue&type=style&index=0&id=2c13942a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c13942a"]])

export default __exports__